module.exports = __webpack_public_path__ + "media/images/tutorial_header_sp2-02-3c94299133e2d57606537436d1108176.png";